import ABCyaPhaser from "@abcya/abcya_phaser";
import Monster from "./Monster";
import FontKeys from "../FontKeys";

export default class HowTo2 extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene);

        this.workingWidth = null;
        this.workingHeight = null;

        this.inst2 = null;
        this.lblOne = null;
        this.monster = null;

        this.inst2 = ABCyaPhaser.Text.addText(0,-6,44, 0xffffff, FontKeys._asapbold, "Feed the Fraction Monster 1s", this, false).setOrigin(0);

        this.monster = new Monster(this.scene);
        this.monster.y = 80;
        this.monster.x = 240;

        this.lblOne = ABCyaPhaser.Images.addImage(122,160, "One", this).setAngle(-20);

        this.add(this.monster);

        this.workingWidth = this.inst2.width;
        this.workingHeight = this.monster.y + this.monster.workingWidth;
    }

    initAnimation() { }

    preUpdate(time, delta)
    {
        this.monster.tick(delta/1000);
    }
}